import { configureStore } from '@reduxjs/toolkit';
import { ENV } from 'config';
import { authMiddleware, authReducer } from 'features/auth';
import { jobPreferencesMiddleware, jobPreferencesReducer } from 'features/jobPreferences';
import { candidateProfileReducer, updateProfileMiddleware } from 'features/profile';
import { toastsReducer } from 'modules/ToastManager';
import candidateAvailabilityReducer from 'pages/candidateAvailability/store';
import availabilityUpdateMiddleware from 'pages/candidateAvailability/store/availabilityMiddleware';
import { candidateOfferReducer } from 'pages/candidateOffer/store';
import { candidateOfferListReducer, offerReplyMiddleware } from 'pages/candidateOfferList';

const store = configureStore({
    reducer: {
        candidateAvailability: candidateAvailabilityReducer,
        candidateOffer: candidateOfferReducer,
        candidateOfferList: candidateOfferListReducer,
        toasts: toastsReducer,
        jobPreferences: jobPreferencesReducer,
        candidateProfile: candidateProfileReducer,
        auth: authReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([
        offerReplyMiddleware.middleware,
        availabilityUpdateMiddleware.middleware,
        jobPreferencesMiddleware.middleware,
        authMiddleware.middleware,
        updateProfileMiddleware.middleware
    ]),
    devTools: ENV.NODE_ENV !== 'production'
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export interface ThunkAPIConfig {
    state: RootState;
    dispatch: AppDispatch;
    rejectValue: string | undefined;
}

const storeMemoised = import.meta.env.DEV
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-underscore-dangle
    ? (globalThis as any).__APP_STORE__ ??= store
    : store;
export default storeMemoised;

console.log("STORE INSTANCE", Date.now());
